import { DataSdk } from "../DataSdk";
import { Authentication } from "../Authentication";

import { TelemetryResult } from "../model/TelemetryResult";

export async function getTelemetry(
  deviceIdOrDeviceIds: string | string[],
  streamNameOrStreamNames: string | string[],
  start: Date,
  end: Date,
  tags?: { [key in string]: string[] },
  latestOnly?: boolean
): Promise<TelemetryResult[]> {
  let deviceIds = deviceIdOrDeviceIds;
  if (!Array.isArray(deviceIdOrDeviceIds)) {
    deviceIds = [deviceIdOrDeviceIds];
  }
  let streamNames = streamNameOrStreamNames;
  if (!Array.isArray(streamNameOrStreamNames)) {
    streamNames = [streamNameOrStreamNames];
  }
  const data = await fetch(`${DataSdk.queryApi}/queries`, {
    method: "POST",
    body: JSON.stringify({
      deviceIds,
      end: end.toISOString(),
      names: streamNames,
      start: start.toISOString(),
      tags,
      latestOnly,
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + Authentication.token,
    },
  });
  const telemetry = await data.json();
  return telemetry.items;
}
